import * as analytic from '@anm/analytic';
import localStorage from '@anm/helpers/localStorage';
import { useCallback, useEffect, useState, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { templateActions, templateSelectors } from '../../../../store/modules/template';
import { userSelectors } from '../../../../store/modules/user';

export const useAlertHandlers = (onModalClose: () => void) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const userId = useSelector(userSelectors.selectUserId);
  const userEmail = useSelector(userSelectors.selectUserEmail);
  const currentTemplate = useSelector(templateSelectors.selectCurrentTemplate);

  useEffect(() => {
    const emailFromLocalStorage = localStorage().getItem('email');

    emailFromLocalStorage && setEmail(emailFromLocalStorage);

    if (!userEmail || !currentTemplate) return;

    const { templateId, meta } = currentTemplate;

    analytic.trackTemplateSendEmail({
      templateId,
      ...(userId && { userId })
    });
    dispatch(
      templateActions.sendTemplateLinkToEmail({
        templateId,
        email: userEmail,
        target: meta.defaultTarget
      })
    );
  }, []);

  const handleButtonClick = useCallback(() => {
    !userEmail && localStorage().setItem('email', email);

    if (!currentTemplate) return;
    const { templateId, meta } = currentTemplate;

    analytic.trackTemplateSendEmail({ templateId, ...(userId && { userId }) });
    dispatch(
      templateActions.sendTemplateLinkToEmail({
        email,
        templateId,
        target: meta.defaultTarget
      })
    );
    onModalClose();
  }, [userEmail, email, currentTemplate]);

  const handleInputChange = useCallback(({ target }: ChangeEvent<HTMLInputElement>) => {
    setEmail(target.value);
  }, []);

  return [email, userEmail, handleButtonClick, handleInputChange] as const;
};
